import { createRoute } from "@tanstack/react-router";
import { FoldersAdmin } from "@/pages/admin/FoldersAdmin";
import { Route as RootRoute } from "./__root";

/**
 * `/admin/folders` route (papki-tenants v1).
 *
 * We deliberately do NOT wrap this in a `RoleGuard`: the FoldersAdmin
 * page itself renders a `data-testid="forbidden"` placeholder for non-
 * admin viewers, which keeps the URL stable (no /-redirect dance) and
 * gives a manager / user a clear "you cannot use this page" affordance
 * if they followed a stale link. The backend still authoritatively
 * rejects writes from non-admins.
 */
export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/folders",
  component: () => <FoldersAdmin />,
});
